import React, { useMemo } from "react";

// ---------- JSON viewer (naive syntax highlight) ----------
export const JsonView = ({ data }) => {
  const text = useMemo(() => JSON.stringify(data, null, 2), [data]);
  const highlighted = useMemo(() => {
    if (!text) return "";
    return text.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g,
      (m) => {
        let cls = "json-num";
        if (/^"/.test(m)) {
          cls = /:$/.test(m) ? "json-key" : "json-str";
        } else if (/true|false/.test(m)) {
          cls = "json-bool";
        } else if (/null/.test(m)) {
          cls = "json-null";
        }
        return `<span class="${cls}">${m}</span>`;
      },
    );
  }, [text]);

  return (
    <pre
      className="mono text-[12px] leading-relaxed bg-card/60 border border-border/60 p-4 overflow-auto max-h-[520px]"
      data-testid="json-viewer"
      dangerouslySetInnerHTML={{ __html: highlighted }}
    />
  );
};
